<p>custom-alert-dialog works!</p>
